import PayrollIncomeCreateComponents from "../components/PayrollIncomeCreate";
import useIncome from "../hooks/useIncome";

const PayrollIncomeCreate = () => {
  const useIncomeProps = useIncome();
  return <PayrollIncomeCreateComponents {...useIncomeProps} />;
};

export default PayrollIncomeCreate;
